import {powerbiComponent} from './_powerbi_utils';

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.component-power-bi--lazy').forEach(function(el) {
    el.outerHTML = powerbiComponent(el);
  })
})
